module.exports = __webpack_public_path__ + "static/media/Tulleord-instruksjoner-Dysmate-A.292b90ac.mp3";